import { useQuery } from '@tanstack/react-query';
import Spinner from 'components/Spinner';
import useGrade from 'components/useGrade';
import useNames from 'components/useNames';
import useReadingAssessmentResponse, { IReadingAssessmentResponse } from 'components/useReadingAssessmentResponse';
import { useEffect, useState } from 'react';
import HTTPClient from 'services/HTTPClient';
import AuthService from 'services/AuthService';
import ReadingAssessments from './ReadingAssessments';
import Button from 'components/Button';
import UsersImporterModal from './UsersImporterModal';

const useIframe = (grade, first_name, last_name) => {
    return useQuery(['student-dashboard'], async () => {
        let query = {
            dashboard_name: "student",
            grade,
            first_name,
            last_name
        }
        const url = `/api/tenant/metabase`
        let response = await HTTPClient.get().getJSONResult(url, query)
        return response.url
    });
};

export default function StudentStatsPage() {
    // let [grade, gradeSelectorRenderer] = useGrade();
    let grade = AuthService.getGrade()
    let [user, namesSelectorRenderer] = useNames();
    const [showUsersImporter, setShowUsersImporter] = useState(false)
    const { data: url, isFetching, error, refetch } = useIframe(grade, user?.firstName, user?.lastName)
    const {
        isLoading: isFetchingReadingAssessments,
        mutateAsync: fetchReadingAssessmentResponses
    } = useReadingAssessmentResponse()
    const [readingAssessmentResponses, setReadingAssessmentResponses] = useState<IReadingAssessmentResponse[]>([])

    useEffect(() => {
        refetch()
        if (user || grade) {
            let query: any = {}
            if (user) {
                query.user_ids = [user.id]
            }
            if (grade) {
                query.grade = grade
            }
            fetchReadingAssessmentResponses(query).then(v => {
                console.log(v)
                setReadingAssessmentResponses(v)
            })
        }
    }, [user, grade, refetch, fetchReadingAssessmentResponses])


    if (isFetching) {
        return <div className="center my-5">
            <Spinner />
        </div>
    }

    return <div className='p-5 w-100 h-100' style={{ height: "100vh", overflow: "auto" }}>
        <h3 className='is-size-3 mb-5'>
            <strong>
                {`${AuthService.getLastNameWithSalutation()}'s Classroom`}
            </strong>
        </h3>
        <div className='d-flex mb-5 between'>
            {/* <div className='mr-2'>
                {gradeSelectorRenderer()}
            </div> */}
            {namesSelectorRenderer()}
            <Button className='mr-2' onClick={() => {
                setShowUsersImporter(true)
            }}>Import Users</Button>
        </div>
        {
            grade
                ? <>
                    <iframe
                        title='metabase'
                        src={url}
                        frameBorder="0"
                        width="100%"
                        onLoad={(obj) => {
                            //@ts-ignore
                            window.iFrameResize({}, this)
                        }}
                    ></iframe>
                    {isFetchingReadingAssessments
                        ? <Spinner />
                        : <ReadingAssessments />
                    }
                </>
                : <em className='center mt-5'>
                    Please select a grade
                </em>
        }
        {showUsersImporter && <UsersImporterModal
            onClose={() => setShowUsersImporter(false)}
        />}
    </div>
}